import { LayoutContainer } from "../../components/layoutContainer";
import { usePhoneConfirmationContext } from "../../context/PhoneConfirmationContext";
import { Button, Typography } from "@mui/material";
import styles from "./styles.module.scss";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

function transformMessageToLinks(message: string, t: (key: string) => string) {
  if (typeof message !== "string") {
    return message;
  }

  const urlRegex = /(https?:\/\/[^\s]+)/g;

  return message.split(urlRegex).map((part, index) => {
    if (urlRegex.test(part)) {
      return (
        <a key={index} href={part} target="_blank" rel="noopener noreferrer">
          {t("clickHere")}
        </a>
      );
    }
    return part;
  });
}

export default function ErrorPage() {
  const { message } = usePhoneConfirmationContext();

  const { t } = useTranslation();

  const handleComeback = () => {
    window.location.href = "/";
  };

  useEffect(() => {
    if (message === "") {
      window.location.href = "/";
    }
  }, [message]);

  return (
    <LayoutContainer>
      <div className={styles.container}>
        <div className={styles.texts}>
          <Typography variant="h5"> {t("errorGeneric")}</Typography>
          <Typography variant="subtitle1">
            {transformMessageToLinks(message, t)}
          </Typography>
        </div>
        <div>
          <Button type="submit" onClick={handleComeback} fullWidth>
            {t("backButtonLabel")}
          </Button>
        </div>
      </div>
    </LayoutContainer>
  );
}
